type DbVersionCheckResult = 'Fail' | 'Success';

interface DbVersionCheckResponse {
  code: number;
  result: number;
  message: string;
}

class DbVersionCheckError extends Error {
  code: number;

  message: string;

  result: DbVersionCheckResult;

  constructor(response: DbVersionCheckResponse) {
    super('Application Database Version Check Error');
    this.code = response.code;
    this.message = response.message;
    this.result = response.result === 0 ? 'Fail' : 'Success';
  }
}

export default DbVersionCheckError;
